import React, { useState, useEffect, useRef } from 'react';
// import { appInsights, reactPlugin } from '../../../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { SelectChangeEvent } from '@mui/material';
import { OptionProps } from '../../../../view-models';
import { TextComponent, SelectComponent } from '../../../uiComponents';
import Button from '@mui/material/Button';
import { gritComponentStyles } from './../../gritComponentStyles';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import { useDispatch, useSelector } from 'react-redux';
import { getClaimsDropdownList, getClaims } from '../../../../store';
import { ClaimComponent } from '../../../gritComponents';
import { init_Claim, init_InputClaim } from '../../../../xmlParsing/initInterfaces';
import { Claim, InputClaim } from '../../../../xmlParsing/interfaces';
import { validateClaim } from '../../../../utils/utils';
import ShowClaimComponent from '../../showClaim';

interface InputClaimComponentProps {
  data: InputClaim;
  list: InputClaim[];
  mode: 'edit' | 'add';
  changeHandler: (val: any) => void;
}

function InputClaimComponent({ data, list, mode, changeHandler }: InputClaimComponentProps) {
  const [modifiedData, setModifiedData] = useState<InputClaim>(init_InputClaim());
  const [newClaim, setNewClaim] = useState<Claim>(init_Claim());
  const [hasError, setError] = useState<boolean>(false);
  const [newClaimSelection, setNewClaimSelection] = useState<string>('selectExisting');
  const [filteredList, setFilteredList] = useState<OptionProps[]>([]);
  const [allClaimsList, setAllClaimsList] = useState<string[]>([]);
  const allClaimsDropdownList = useSelector(getClaimsDropdownList);
  const allClaims = useSelector(getClaims);
  const classes = gritComponentStyles();
  useEffect(() => {
    if (mode === 'edit') {
      setModifiedData(data);
      setError(false);
    }
    if (mode === 'add') {
      setModifiedData(init_InputClaim());
      if (newClaimSelection === 'selectExisting' && allClaimsDropdownList.length > 0) {
        const availableList = list.reduce(
          (acc: string[], curVal: InputClaim) => acc.concat([curVal.claimTypeReferenceId]),
          [],
        );
        setFilteredList(
          allClaimsDropdownList
            .filter((el: OptionProps) => !availableList.includes(el.value))
            .sort((a: OptionProps, b: OptionProps) => (a.value.toLowerCase() > b.value.toLowerCase() ? 1 : -1)),
        );
        setError(false);
      }
      if (newClaimSelection === 'addNew') {
        setError(true);
        setAllClaimsList(
          allClaimsDropdownList.reduce((acc: string[], curVal: OptionProps) => acc.concat([curVal.value]), []),
        );
      }
    }
  }, [data, list, mode, newClaimSelection, allClaimsDropdownList]);

  useEffect(() => {
    filteredList.length > 0 && setModifiedData({ ...modifiedData, claimTypeReferenceId: filteredList[0].value });
  }, [filteredList]);

  useEffect(() => {
    if (newClaim['userInputType'] === 'Paragraph') setModifiedData({ ...modifiedData, required: false });
    setError(validateClaim(newClaim, allClaims));
  }, [newClaim]);
  return (
    <>
      <h3>Input Claims</h3>
      {mode === 'add' && (
        <div id="add-claimTypeReferenceId">
          <FormControl>
            <RadioGroup
              row
              value={newClaimSelection}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setNewClaimSelection(e.target.value);
              }}
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
            >
              <FormControlLabel
                value="selectExisting"
                control={<Radio />}
                label="Select from existing claimTypeReferenceId"
              />
              <FormControlLabel value="addNew" control={<Radio />} label="Add a new Claim" />
            </RadioGroup>
          </FormControl>
          <hr />
        </div>
      )}
      {modifiedData && (
        <div className={classes.flexCol}>
          <div>
            {mode === 'edit' && <ShowClaimComponent data={allClaims[modifiedData.claimTypeReferenceId]} />}
            {mode === 'add' && newClaimSelection === 'selectExisting' && filteredList.length > 0 && (
              <SelectComponent
                changeHandler={(e: SelectChangeEvent<string>) => {
                  setModifiedData({ ...modifiedData, claimTypeReferenceId: e.target.value });
                }}
                data={{
                  value: modifiedData['claimTypeReferenceId'] || filteredList[0]['value'],
                  label: 'Select ClaimTypeReferenceId',
                  style: { margin: 1, width: 400 },
                  options: filteredList,
                }}
              />
            )}
            {mode === 'add' && newClaimSelection === 'addNew' && (
              <ClaimComponent
                data={newClaim}
                changeHandler={(newClaim: Claim) => {
                  setNewClaim(newClaim);
                }}
              />
            )}
          </div>
          <div>
            <FormControlLabel
              sx={{ m: 0 }}
              label="required"
              control={
                <Checkbox
                  checked={modifiedData['required'] || false}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setModifiedData({ ...modifiedData, required: !modifiedData['required'] });
                  }}
                />
              }
            />
            <FormControlLabel
              sx={{ m: 0 }}
              label="alwaysUseDefaultValue"
              control={
                <Checkbox
                  checked={modifiedData['alwaysUseDefaultValue'] || false}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setModifiedData({ ...modifiedData, alwaysUseDefaultValue: !modifiedData['alwaysUseDefaultValue'] });
                  }}
                />
              }
            />
          </div>
          <div className={classes.flexRowCenter}>
            <SelectComponent
              changeHandler={(e: SelectChangeEvent<string>) => {
                setModifiedData({ ...modifiedData, partnerClaimType: e.target.value });
              }}
              data={{
                value: modifiedData['partnerClaimType'] || 'email',
                label: 'Select partnerClaimType',
                options: [
                  { label: 'email', value: 'email' },
                  { label: 'objectid', value: 'objectid' },
                  { label: 'alternativeSecurityId', value: 'alternativeSecurityId' },
                ],
              }}
            />
            <TextComponent
              changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
                setModifiedData({ ...modifiedData, defaultValue: e.target.value });
              }}
              data={{
                value: modifiedData['defaultValue'] || '',
                label: 'defaultValue',
              }}
            />
          </div>
          <footer className={classes.footer}>
            <Button
              variant="contained"
              color="primary"
              disabled={hasError}
              onClick={() => {
                if (mode === 'add' && newClaimSelection === 'selectExisting')
                  changeHandler({
                    ioclaim: { ...modifiedData, claimTypeReferenceId: modifiedData['claimTypeReferenceId'] },
                    claim: {},
                  });
                else if (mode === 'add' && newClaimSelection === 'addNew')
                  changeHandler({
                    ioclaim: { ...modifiedData, claimTypeReferenceId: newClaim['id'] },
                    claim: newClaim,
                  });
                else changeHandler({ ioclaim: modifiedData });
              }}
            >
              {mode === 'add' ? 'Add' : 'Update'}
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={() => {
                changeHandler(null);
              }}
            >
              Cancel
            </Button>
          </footer>
        </div>
      )}
    </>
  );
}

// export default withAITracking(reactPlugin, InputClaimComponent);
export default InputClaimComponent;
